import { TrainingProgramRecord } from '@app/models/training/training-program-record.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import { Translatable } from '@app/types/translatable.type';
import { TrainingProgramRecordsStatusDisplayOptions } from '@app/types/translatables/training-display.options';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { format } from 'date-fns';

export enum TrainingProgramRecordBadgeTypes {
    pending = 'warning',
    overdue = 'danger',
    complete = 'default',
}

export class StatusColumn extends BadgeColumn<TrainingProgramRecord> {
    title = 'training.trainingStatus';
    property = 'status';
    type: CellDisplay = CellDisplay.badge;

    constructor() {
        super();

        const options = [
            {
                label: 'training.pending',
                value: 'pending',
            },
            {
                label: 'training.complete',
                value: 'complete',
            },
            {
                label: 'training.overdue',
                value: 'overdue',
            },
        ];

        this.filter = new CheckListFilter('status', options);
    }

    getBadgeType(trainingProgramRecord: TrainingProgramRecord): BadgeType {
        return TrainingProgramRecordBadgeTypes[trainingProgramRecord.status];
    }

    getBadgeDisplay(trainingProgramRecord: TrainingProgramRecord): BadgeDisplay | undefined {
        if (trainingProgramRecord.isComplete) {
            return;
        }

        const label =
            TrainingProgramRecordsStatusDisplayOptions[trainingProgramRecord.status ?? ''] ??
            trainingProgramRecord.status.toUpperCase();

        return {
            type: this.getBadgeType(trainingProgramRecord),
            label,
        };
    }

    getCellText(trainingProgramRecord: TrainingProgramRecord): Translatable | null {
        if (!trainingProgramRecord.isComplete) {
            return;
        }

        return {
            key: 'training.completedOn',
            params: { date: format(trainingProgramRecord.completedAt, 'MMM D, YYYY') },
        };
    }
}
